export const ESTADO_REVISION_CESIONES = {
  CREADA: 1,
  COMUNICADA: 2,
  ACEPTADA_MANUALMENTE: 3,
  ACEPTADA: 4,
  CANCELADA: 5,
  FINALIZADA: 6,
  RECHAZADA: 7,
}
